import {
	ArrayUtil,
	btn, Button,
	comp,
	DataSourceForm,
	datasourceform,
	displaydatefield,
	displayfield,
	hr,
	menu, Notifier,
	tbar, Window
} from "@intermesh/goui";
import {
	addbutton,
	client,
	DetailPanel,
	filesbutton,
	jmapds,
	linkbrowsebutton,
	modules
} from "@intermesh/groupoffice-core";
import {FormWindow} from "./FormWindow";
import {Form} from "./Form";
import {FormFieldDetail} from "./FormFieldDetail";
import {FormParticipantDetail} from "./FormParticipantDetail";
import {SendWindow} from "./SendWindow";

import {t} from "./Translate";


export class FormDetail extends DetailPanel<Form> {
	private form: DataSourceForm<Form>;
	private fields: FormFieldDetail;
	private participants: FormParticipantDetail;
	private archiveBtn: Button;

	constructor() {
		super("Form");

		this.fields = new FormFieldDetail();

		this.participants = new FormParticipantDetail();

		this.scroller.items.add(
			this.form = datasourceform({
				dataSource: jmapds("Form")
			},

				comp({cls: "card "},

					tbar({},
						comp({},
							displayfield({tagName: "h3", name: "title"}),
							displayfield({tagName: "small", name: "description"})
						)
					),


					tbar({style: {justifyContent: "space-evenly"}},
						btn({
							icon: "send",
							text: t("Send"),
							cls: "primary",
							handler: () => {
								const win = new SendWindow(this.entity!.id);
								win.show();
							}
						}),



						btn({
							icon: "content_copy",
							cls: "accent",
							text: t("Duplicate"),
							handler: () => {
								const dlg = new FormWindow();
								const copy = structuredClone(this.entity!) as any;
								delete copy.id;
								copy.title += " (1)"

								copy.fields.map((f:any) => delete f.id);

								dlg.form.value = copy
								dlg.show();
							}
						}),

						btn({
							icon: "download",
							text: t("Download report"),
							handler: () => {
								document.location = client.downloadUrl("business/forms/report/" + this.entity!.id);
							}
						}),

						this.archiveBtn = btn({
							icon: "archive",
							cls: "danger",
							text: t("Archive"),
							handler: async () => {
								this.mask();
								try {
									await jmapds("Form").update(this.entity!.id, {archived: !this.entity!.archived})
								} catch(e:any) {
									console.error(e);
									Window.error(e.message);
								}
								this.unmask();
							}
						})
						),



					comp({cls: "pad flow"},



						displaydatefield({
							name: "dateOpen",
							label: t("Open"),
							width: 160
						}),

						displaydatefield({
							name: "dateClosed",
							label:t("Closed"),
							width: 160
						}),

						displaydatefield({
							name: "sentAt",
							label: t("First sent at"),
							width: 160
						}),




					)
				)
			),

			this.fields,
			this.participants
		)


		this.addCustomFields();
		this.addComments();
		// this.addFiles();
		this.addLinks();
		this.addHistory();

		this.toolbar.items.add(

			btn({
				icon: "edit",
				title: t("Edit"),
				handler: (button, ev) => {
					const dlg = new FormWindow();
					void dlg.load(this.entity!.id);
					dlg.show();
				}
			}),

			addbutton(),

			linkbrowsebutton(),

			btn({
				icon: "more_vert",
				menu: menu({},
					btn({
						icon: "print",
						text: t("Print"),
						handler: () => {
							this.print();
						}
					}),

					hr(),

					btn({
						icon: "delete",
						text: t("Delete"),
						handler: () => {
							jmapds("Form").confirmDestroy([this.entity!.id]);
						}
					})
					)
			})
		)

		this.on("load",({entity}) => {
			this.title = entity.title;
			void this.form.load(entity.id);
			this.archiveBtn.text = entity.archived ? t("Unarchive") : t("Archive");
			this.fields.load(entity);
			this.participants.load(entity);
		});

		this.on("reset", () => {
			this.form.reset();
		});
	}

}